import { render, staticRenderFns } from "./BaseRow.vue?vue&type=template&id=6240cf10&"
import script from "./BaseRow.vue?vue&type=script&lang=js&"
export * from "./BaseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports